import { colors, fonts } from 'shared/defaultTheme';
import styled from 'styled-components';

export const FilesWrapper = styled.div`
  .files-box-container {
    box-sizing: border-box;
    height: auto;
    width: 100%;
    border-radius: 8px;
    height: 845px;
    display: grid;
    grid-template-rows: 95.3% 5%;
    .control-panel__table {
      height: auto;
      overflow: auto;
      max-height: 700px;
      padding: 15px;
    }
    .image-uploader {
      width: 100%;
      border-radius: 2px;
      .span-custom-title {
        color: ${colors.black};
        font-family: ${fonts.default};
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 16px;
        position: relative;
        top: 2px;
      }
      &:hover {
        div {
          span {
            color: ${colors.zambezi};
          }
          svg {
            fill: ${colors.zambezi};
          }
        }
      }
    }
    .notification-drag-text {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 15px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 18px;
      text-align: center;
    }
    .notification-drag-divider {
      box-sizing: border-box;
      height: 1px;
      width: 263px;
      border: 1px solid ${colors.pattens};
    }
    .notification-explore-computer {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 15px;
      text-align: center;
    }
    .button-upload-footer {
      width: 100%;
    }
  }
`;
